import { Helmet } from "react-helmet-async";
import "./style.css";
import NavbarTop from "../../components/NavbarTop";
import { useEffect, useRef, useState, useCallback } from "react";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import PostList from "../../components/Post/PostList";
import ImgProfilePost from "../../components/Post/ImgProfilePost";
import UserName from "../../components/Post/UserName";
import ImgPost from "../../components/Post/ImgPost/ImgPost";
import { useAuth, useTheme } from "../../global-components/src";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Community, StatusString } from "../../types";
import { useMessage } from "../../global-components/src";
import { Copy, Edit, LogIn, MessageSquare, Search, Trash, UserMinus, UserPlus, Users } from "react-feather";
// import AddPost from "../../components/Modals/AddPost/AddPost";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import ModalPostLikes from "../Posts/PostLikes/ModalPostLikes";
// import ModalPostComments from "../Posts/PostLikes/ModalPostComments";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import AddPostBottom from "../../components/Modals/add-post/add-post-bottom";
import AddPost from "../../components/Modals/add-post/add-post";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import { LeftContent, RightContent, Sponsored, SponsoredContent } from "../../global-components/src/components/screen/left-content";
import UserSearch from "../Settings/SearchScreen/User/User";
import { IconLateralContent } from "../../global-components/src/components/screen/icon-lateral-content";
import { UserSearchLoadin } from "../Settings/SearchScreen/User/UserSearchLoading";
import { Check, ChevronDown, ChevronRight, ClipboardList, Clock, MessageCircle, Plus, Trash2, UserMinus2, X } from "lucide-react";
import { curry, debounce } from "lodash";
import BottomSheet from "../../components/bottom-sheet/bottom-sheet";
import ModalComments from "../../components/Modals/comments/modal-comments";
import { Icon } from "../../global-components/src/components/icon";
import { useAddPost } from "../../contexts/AddPostContext";
import { getNativeNavigationHeight, isNewApp, isNewAppAndroid } from "../../utils/platform";
import { isIOSWebView } from "../../global-components/src/utils/platform";
import { useTranslation } from "react-i18next";
import { User } from "../../global-components/src/types";
import { invalidateChatListCache } from "../../utils/chat-list-cache";

const ViewCommunity: React.FC = () => {
    const [posts, setPosts] = useState<any[]>([]);
    const [cursor, setCursor] = useState<number | null>(null);
    const { id: communityId } = useParams(); // Obtém o ID do post da URL
    const [loading, setLoading] = useState(false);
    const [loadingCommunity, setLoadingCommunity] = useState(false);
    const [members, setMembers] = useState<User[] | null>([]);
    const [membersTotal, setMembersTotal] = useState<number>(0);
    const [admins, setAdmins] = useState<User[] | null>([]);
    const [statusMembers, setStatusMembers] = useState<StatusString>(StatusString.loading);
    const [statusAdmins, setStatusAdmins] = useState<StatusString>(StatusString.loading);
    const [showMembersMobile, setShowMembersMobile] = useState<boolean>(false);
    const [showAllMembersModal, setShowAllMembersModal] = useState(false);
    const { isDarkMode, isNewUI } = useTheme();
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(1);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [feedType, setFeedType] = useState("feed");
    const [community, setCommunity] = useState<Community | null>(null);
    const [isMember, setIsMember] = useState<boolean | null>(null);
    const [backgroundColor, setBackgroundColor] = useState<string>("var(--background-post)");
    const [error, setError] = useState("");
    const { user, token } = useAuth();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const [password, setPassword] = useState(''); // Adicione um estado para a senha
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [errorModal, setErrorModalPassword] = useState(''); // Adicione um estado para a senha
    const [isLoading, setIsLoading] = useState(false); // Adicione um estado para a senha
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null);
    const [termo, setTermo] = useState("");
    const [termoAdmin, setTermoAdmin] = useState("");
    const [debouncedTermo, setDebouncedTermo] = useState("");
    const [debouncedTermoAdmin, setDebouncedTermoAdmin] = useState("");
    const [openSettings, setOpenSettings] = useState(false);
    const [bottomPadding, setBottomPadding] = useState(60);
    const [pendingPosts, setPendingPosts] = useState<any[]>([]);
    const [loadingPendingPosts, setLoadingPendingPosts] = useState(false);
    const [showPendingPosts, setShowPendingPosts] = useState(false);
    const [joinRequests, setJoinRequests] = useState<any[]>([]);
    const [loadingJoinRequests, setLoadingJoinRequests] = useState(false);
    const [showJoinRequests, setShowJoinRequests] = useState(false);
    const [activeTab, setActiveTab] = useState<"feed" | "pendingPosts" | "joinRequests" | "members" | "photos" | "videos">("feed");
    // Photos tab state
    const [photoPosts, setPhotoPosts] = useState<any[]>([]);
    const [photoCursor, setPhotoCursor] = useState<number | null>(null);
    const [loadingPhotos, setLoadingPhotos] = useState(false);
    const [endPhotos, setEndPhotos] = useState(false);
    // Videos tab state
    const [videoPosts, setVideoPosts] = useState<any[]>([]);
    const [videoCursor, setVideoCursor] = useState<number | null>(null);
    const [loadingVideos, setLoadingVideos] = useState(false);
    const [endVideos, setEndVideos] = useState(false);
    const path = location.pathname;
    const { setOpen: setOpenPost } = useAddPost();

    const handleChangeAdmin = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermoAdmin(inputValue); // atualiza imediatamente o campo
        debouncedHandleInputAdmin(inputValue); // dispara o debounce
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setTermo(inputValue); // atualiza imediatamente o campo
        debouncedHandleInput(inputValue); // dispara o debounce
    };

    const debouncedHandleInputAdmin = useCallback(debounce((value: string) => { setDebouncedTermoAdmin(value); }, 500), []);
    useEffect(() => {
        loadAdmins(1);
    }, [debouncedTermoAdmin]);
    const handleKeyDownAdmin = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadAdmins(1)
        }
    };
    
    const debouncedHandleInput = useCallback(debounce((value: string) => { setDebouncedTermo(value); }, 500), []);
    useEffect(() => {
        loadMembers(1);
    }, [debouncedTermo]);
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            loadMembers(1)
        }
    };

    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + 60);
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);
    useEffect(() => {
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const menu = document.querySelector('.button-add-post-feed') as HTMLElement;
            if (!menu) return;

            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-bottom-button");
                } else {
                    menu.classList.remove("hidden-bottom-button");
                }
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [path]);

    useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false)
            setShowModalComments(false)
            setIdPostSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    const copyLinkCommunity = (id?: string) => {
        const link = `${window.location.origin}/comunidades/${id}`;
        
        if (navigator.share) {
            navigator.share({
                title: `Compartilhar comunidade`,
                url: link,
            }).catch((error) => console.error('Erro ao compartilhar o link:', error));
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(link)
                .then(() => alert('Link da conta copiado!'))
                .catch((error) => console.error('Erro ao copiar o link:', error));
        } else {
            alert('Copie este link: ' + link);
        }
    };

    const handleJoinCommunity = async () =>{
        const url = isMember ? `${PACOCA_API_URL}/communities/exit/${communityId}` : `${PACOCA_API_URL}/communities/join/${communityId}`;

        try {
            const response = await axios.post(url, {
                community_id: communityId
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (response.data.pending) {
                // Private community — request sent, not yet a member
                setCommunity(prev => prev ? { ...prev, pending_join: true } : prev);
                setMessage(t("community.joinRequestSent"), "success");
                return;
            }

            setIsMember(!isMember)
            invalidateChatListCache(user?.id);
            
        } catch (err: any) {
            if(err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");
            
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setMessage(err.response.data.message || "Erro ao entrar!", "error");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setMessage("Ocorreu um erro inesperado!", "error");
            }
        } finally {
            setLoadingCommunity(false);
        }
    }

    const handleTogglePostApproval = async () => {
        try {
            const response = await axios.post(
                `${PACOCA_API_URL}/communities/${communityId}/toggle-post-approval`,
                {},
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setCommunity(prev => prev ? { ...prev, post_approval: response.data.post_approval } : prev);
            setMessage(response.data.message, "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro ao alterar configuração", "error");
        }
    };

    useEffect(() => {
        if(window.innerWidth > 850) {
            loadPendingPosts();
            loadJoinRequests();
        }
    }, [community])

    const loadJoinRequests = async () => {
        if (!communityId) return;
        setLoadingJoinRequests(true);
        try {
            const response = await axios.get(
                `${PACOCA_API_URL}/communities/${communityId}/join-requests`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setJoinRequests(response.data.requests || []);
        } catch {
            // silently fail — might not be admin
        } finally {
            setLoadingJoinRequests(false);
        }
    };

    const handleApproveJoin = async (userId: number) => {
        try {
            await axios.post(
                `${PACOCA_API_URL}/communities/${communityId}/join-requests/${userId}/approve`,
                {},
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setJoinRequests(prev => prev.filter(r => r.user_id !== userId));
            setMessage(t("community.approveJoin") + "!", "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro", "error");
        }
    };

    const handleRejectJoin = async (userId: number) => {
        try {
            await axios.delete(
                `${PACOCA_API_URL}/communities/${communityId}/join-requests/${userId}`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setJoinRequests(prev => prev.filter(r => r.user_id !== userId));
            setMessage(t("community.rejectJoin") + "!", "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro", "error");
        }
    };

    const handleCancelJoinRequest = async () => {
        try {
            await axios.delete(
                `${PACOCA_API_URL}/communities/${communityId}/join-request`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setCommunity(prev => prev ? { ...prev, pending_join: false } : prev);
            setMessage(t("community.joinRequestCancelled"), "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro", "error");
        }
    };


    const loadPendingPosts = async () => {
        if (!communityId) return;
        if (!community?.is_admin) return;
        setLoadingPendingPosts(true);
        try {
            const response = await axios.get(
                `${PACOCA_API_URL}/communities/${communityId}/pending-posts`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setPendingPosts(response.data.posts || []);
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro ao carregar posts pendentes", "error");
        } finally {
            setLoadingPendingPosts(false);
        }
    };

    const handleApprovePost = async (postId: number) => {
        try {
            await axios.post(
                `${PACOCA_API_URL}/communities/${communityId}/pending-posts/${postId}/approve`,
                {},
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setPendingPosts(prev => prev.filter(p => p.id !== postId));
            // Add the approved post to the feed
            setPosts(prev => {
                const approved = pendingPosts.find(p => p.id === postId);
                if (!approved) return prev;
                return [{ ...approved, pending_approval: false }, ...prev];
            });
            setMessage(t("community.approvePost") + "!", "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro ao aprovar post", "error");
        }
    };

    const handleRejectPost = async (postId: number) => {
        try {
            await axios.delete(
                `${PACOCA_API_URL}/communities/${communityId}/pending-posts/${postId}`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            setPendingPosts(prev => prev.filter(p => p.id !== postId));
            setMessage(t("community.rejectPost") + "!", "success");
        } catch (err: any) {
            setMessage(err?.response?.data?.message || "Erro ao recusar post", "error");
        }
    };

    // Armazenando a posição de rolagem
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    
    useEffect(() => {
        if (location.pathname.includes("/comunidades/")) { // só na home
            if (scrollPosition) {
                window.scrollTo(0, parseInt(scrollPosition));
            }
        }
    }, [location.pathname]);


    const handleDelete = () =>{
        setPassword("");
        setShowConfirmation(true);
    }

    const loadCommunity = async () => {
        const url = `${PACOCA_API_URL}/communities/${communityId}`;

        if (loadingCommunity || end) return;
        setLoadingCommunity(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data;

            if (data.community) {
                setIsMember(data.isMember)
                setCommunity(data.community)
                setBackgroundColor(data.community.color)
            } else {
                setEnd(true);
            }
            
        } catch (err: any) {
            if(err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");
            
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setMessage(err.response.data.message || "Erro ao carregar dados!", "error");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setMessage("Ocorreu um erro inesperado!", "error");
            }
        } finally {
            setLoadingCommunity(false);
        }
    };

    useEffect(() => {
        loadCommunity()
    }, []);

    const confirmDeleteCommunity = async(password: string) => {
        const url = `${PACOCA_API_URL}/communities/${communityId}`;
        setIsLoading(true)
        try {
            if(!password){
                setErrorModalPassword("Informe sua senha")
                return;
            }
                
            await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                params: { id_community: communityId, password }
            });
            

            setShowConfirmation(false)
            setPassword("");
            localStorage.removeItem(`myCommunities-${user?.id}`);
            invalidateChatListCache(user?.id);
            navigate("/comunidades")
            setMessage("Comunidade excluida", "success");
        } catch (err: any) {
            if (err.response) {
                console.error("Erro no servidor:", err.response.status, err.response.data);
                if (err.response.status === 401) {
                    setErrorModalPassword(t("generics.errors.sessionExpired"))
                }
                else if (err.response.status === 429 && err.response.data.message) {
                    setErrorModalPassword(t("generics.errors.tooManyRequests", { minutes: err.response.data.remaining ?? 5 }))
                }
                else if (err.response.status === 429) {
                    setErrorModalPassword(t("generics.errors.tooManyRequestsGeneric"));
                }
                else if (err.response) {
                    // O servidor respondeu com um código de erro
                    console.error("Erro no servidor:", err.response.status, err.response.data);
                    setErrorModalPassword(err.response.data.message || "Erro ao fazer post!")
                }
            }
            console.error('Erro:', err);
        } finally{
            setIsLoading(false)
        }
    };

    const loadPosts = async (cursorParam: number | null = cursor) => {
        const publicUrl = !isAuthenticated ? "/public" : "";
        let url = PACOCA_API_URL + publicUrl + `/posts?page=${page}&feedType=${feedType}&communityId=${communityId}`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts;
            setCursor(response.data.next_cursor);

            if (data.length > 0) {
                setPosts((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos
            
                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
            
                    const updatedPosts = [...prev, ...newPosts];
            
                    // Salva os posts no sessionStorage
                    sessionStorage.setItem('posts', JSON.stringify(updatedPosts));
            
                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }
            
        } catch (err: any) {
            console.error("Failed to load posts:", err);
            if (err.status == 401) setError(t("generics.errors.sessionExpired"));
            setEnd(true);
            if(err.status == 429)
                setError(t("generics.errors.tooManyRequestsGeneric"))
        } finally {
            setLoading(false);
        }
    };

    const loadMediaPosts = async (mediaType: "photos" | "videos", cursorParam?: number | null) => {
        const isPhotos = mediaType === "photos";
        const loading  = isPhotos ? loadingPhotos : loadingVideos;
        const end      = isPhotos ? endPhotos : endVideos;
        const setLoadingFn  = isPhotos ? setLoadingPhotos : setLoadingVideos;
        const setEndFn      = isPhotos ? setEndPhotos     : setEndVideos;
        const setPostsFn    = isPhotos ? setPhotoPosts    : setVideoPosts;
        const setCursorFn   = isPhotos ? setPhotoCursor   : setVideoCursor;
        const cursor        = cursorParam !== undefined ? cursorParam : (isPhotos ? photoCursor : videoCursor);

        if (!communityId || loading || end) return;
        setLoadingFn(true);

        try {
            const publicUrl = !isAuthenticated ? "/public" : "";
            let url = `${PACOCA_API_URL}${publicUrl}/posts?feedType=feed&communityId=${communityId}&mediaType=${mediaType}`;
            if (cursor) url += `&cursor=${cursor}`;

            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts ?? [];
            setCursorFn(response.data.next_cursor ?? null);

            if (data.length > 0) {
                setPostsFn(prev => {
                    const existingIds = new Set(prev.map((p: any) => p?.id));
                    const newPosts = data.filter((p: any) => !existingIds.has(p?.id));
                    return newPosts.length === 0 ? prev : [...prev, ...newPosts];
                });
            } else {
                setEndFn(true);
            }
        } catch {
            setEndFn(true);
        } finally {
            setLoadingFn(false);
        }
    };

    const loadAdmins = async (page: number) => {
        if(!communityId) return;
        const url = `${PACOCA_API_URL}/communities/members/${communityId}?search=${termo}&just_admin=1`;
        setAdmins([]);
        setStatusAdmins(StatusString.loading);
        if(window.innerWidth <= 850) return;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.users;
            

            if (data.length > 0) {
                setAdmins((prev) => {
                    const existingIds = new Set(prev?.map(community => community?.id)); // Cria um Set com os IDs existentes
                    const newCommunity = data.filter((community: { id: any; }) => !existingIds.has(community?.id)); // Filtra apenas posts novos
            
                    if (newCommunity.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
            
                    const updatedPosts = [...(prev || []), ...newCommunity];
            
                    // Salva os posts no sessionStorage
                    sessionStorage.setItem(`admins-${communityId}`, JSON.stringify(updatedPosts));
            
                    return updatedPosts;
                });
            }
            setStatusAdmins(StatusString.success);
            
        } catch (err: any) {
            setStatusAdmins(StatusString.error);
        }
    };

    const loadMembers = async (page: number, skipMobileCheck = false) => {
        if(!communityId) return;
        if(window.innerWidth <= 850 && !skipMobileCheck) return;
        // Sidebar always loads only 5 preview members
        const url = `${PACOCA_API_URL}/communities/members/${communityId}?search=${termo}&just_admin=0&limit=5`;
        setMembers([]);
        setStatusMembers(StatusString.loading);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.users;
            if (response.data.total !== undefined) setMembersTotal(response.data.total);

            setMembers(data ?? []);
            setStatusMembers(StatusString.success);
            
        } catch (err: any) {
            setStatusMembers(StatusString.error);
        }
    };

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        loadPosts(cursor);
        // Salva a página atual no localStorage
        sessionStorage.setItem('page', page.toString());
    }, [page, feedType]);

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

    useEffect(() => {
        // Salva a posição de rolagem quando o feed for modificado
        const handleScroll = () => {
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const onClose = () =>{
        setPassword("");
        setShowConfirmation(false)
    }

    const inputLogin = () => {
        if(!isAuthenticated) return { onClick: () => navigate("/login") }

        return { onClick: () => setOpenPost(true) }
        // if (window.innerWidth <= 850) {
        //     return {
        //     onClick: () => {
        //         const btn = document.querySelector("#open-post-mobile");
        //         if (btn) (btn as HTMLButtonElement).click();
        //         else console.warn("Botão #open-post-mobile não encontrado");
        //     },
        //     };
        // }

        // return { "data-bs-toggle": "modal", "data-bs-target": "#modal-post", onClick: () => {} }
    }


    return (
        <div className="container container-feed container-view-community" style={{ paddingTop: "60px", minWidth: "100%!important", minHeight: "100dvh" }}>
            <Helmet> 
                <title>Paçoca - Comunidade - {community?.name ? community?.name : ""}</title>
                <meta name="description" content={`Comunidade do Paçoca - ${community?.description}`}/>
                <meta name="keywords" content={`${community?.name?.split(' ').slice(0, 5).join(', ')}, ${community?.description?.split(' ').slice(0, 5).join(', ')}`}/>
                <meta name="author" content="Paçoca Inc."/>
                <meta property="og:title" content={`Paçoca - Comunidade - ${community?.name}`}/>
                <meta property="og:description" content="Conecte-se com pessoas e faça novos amigos na Paçoca, a rede social inovadora e divertida."/>
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href}/>
                <meta property="og:type" content="website"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={`Paçoca - Comunidade - ${community?.name}`}/>
                <meta name="twitter:description" content={`Comunidade do Paçoca - ${community?.description}`}/>
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>

            <ConfirmationModal 
                show={showConfirmation} 
                onClose={() => onClose()} 
                onConfirm={() => confirmDeleteCommunity(password)} // Passa a senha aqui
                title='Excluir comunidade'
                text='Todos os posts serão excluidos e não é possível recuperar'
                requirePassword={true}                
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={errorModal}
                isLoading={isLoading}
                idModal="delete-community"
                closeRef={closeRef}
            />

            <LeftContent hasDefault={false}>
                <div className="card-left" style={{ borderRadius:"50%" }}>
                    <h5>{t("community.adm")}</h5>
                    <AdminsContent statusMembers={statusAdmins} members={admins} termo={termoAdmin} handleChange={handleChangeAdmin} handleKeyDown={handleKeyDownAdmin} community={community} setUsers={setMembers} setAdmins={setAdmins}/>
                </div>
                
                <div className="card-left" style={{ borderRadius:"50%" }}>
                    <h5>{t("community.members")} {membersTotal > 0 ? `(${membersTotal})` : ""}</h5>
                    <MembersContent statusMembers={statusMembers} members={members} termo={termo} handleChange={handleChange} handleKeyDown={handleKeyDown} community={community} setUsers={setMembers} setAdmins={setAdmins} total={membersTotal} onSeeAll={() => setShowAllMembersModal(true)}/>
                    {showAllMembersModal && communityId && (
                        <AllMembersModal
                            communityId={communityId}
                            token={token}
                            community={community}
                            setUsers={setMembers}
                            setAdmins={setAdmins}
                            onClose={() => setShowAllMembersModal(false)}
                        />
                    )}
                </div>
            </LeftContent>
            <RightContent hasDefault={false}>
                <div className="card-left" style={{ borderRadius:"50%" }}>
                    <h5>{t("settings.title")}</h5>
                    {community?.can_edit && (
                        <div className="notification_opened row-notification open-notification row-user">
                            <span onClick={() => navigate(`/comunidades/editar/${communityId}`)} className="name-likes" style={{ paddingLeft: 0 }}>
                                <Edit style={{ height: '19px', marginRight: '3px' }}/>
                                {t("community.edit")}
                            </span>
                        </div>
                    )}
                    
                    {community?.can_edit && (
                        <div className="notification_opened row-notification open-notification row-user">
                            <span onClick={handleDelete} className="name-likes" style={{ paddingLeft: 0 }}>
                                <Trash2 style={{ height: '19px', marginRight: '3px' }}/>
                                {t("community.delete")}
                            </span>
                        </div>
                    )}

                    {community?.is_admin && community?.post_approval ? (
                        <div className="notification_opened row-notification open-notification row-user">
                            <span
                                onClick={() => {
                                    if (!showPendingPosts) loadPendingPosts();
                                    setShowPendingPosts(prev => !prev);
                                }}
                                className="name-likes"
                                style={{ paddingLeft: 0 }}
                            >
                                <ClipboardList style={{ height: '19px', marginRight: '3px' }} />
                                {t("community.pendingPosts")}
                                {pendingPosts.length > 0 && (
                                    <span style={{
                                        background: "#e74c3c",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        padding: "1px 7px",
                                        marginLeft: "6px",
                                        fontSize: "11px",
                                    }}>{pendingPosts.length}</span>
                                )}
                            </span>
                        </div>
                    ) : null}

                    {community?.is_admin && community?.is_private ? (
                        <div className="notification_opened row-notification open-notification row-user">
                            <span
                                onClick={() => {
                                    if (!showJoinRequests) loadJoinRequests();
                                    setShowJoinRequests(prev => !prev);
                                }}
                                className="name-likes"
                                style={{ paddingLeft: 0 }}
                            >
                                <UserPlus style={{ height: '19px', marginRight: '3px' }} />
                                {t("community.joinRequests")}
                                {joinRequests.length > 0 && (
                                    <span style={{
                                        background: "#e74c3c",
                                        color: "#fff",
                                        borderRadius: "10px",
                                        padding: "1px 7px",
                                        marginLeft: "6px",
                                        fontSize: "11px",
                                    }}>{joinRequests.length}</span>
                                )}
                            </span>
                        </div>
                    ) : null}
                    
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={() => { navigate(`/comunidades/membros/${communityId}`) }} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Users style={{ height: '19px', marginRight: '3px' }}/>
                            {t("community.members")} {!community?.total_members || community?.total_members <=0 ? "" : `(${community?.total_members})`}
                        </span>
                    </div>

                    {community?.chat_id && isMember && (
                        <div className="notification_opened row-notification open-notification row-user">
                            <span onClick={() => navigate(`/chat/${community.chat_id}`)} className="name-likes" style={{ paddingLeft: 0 }}>
                                <MessageCircle style={{ height: '19px', marginRight: '3px' }}/>
                                {t("community.chat")}
                            </span>
                        </div>
                    )}
                    
                    <div className="notification_opened row-notification open-notification row-user">
                        <span onClick={() => copyLinkCommunity(communityId)} className="name-likes" style={{ paddingLeft: 0 }}>
                            <Copy style={{ height: '19px', marginRight: '3px' }}/>
                            {t("community.copyLink")}
                        </span>
                    </div>
                    
                    <div className="notification_opened row-notification open-notification row-user">
                        {community?.pending_join ? (
                            <span onClick={handleCancelJoinRequest} className="name-likes" style={{ paddingLeft: 0 }}>
                                <Clock style={{ height: '19px', marginRight: '3px' }}/>{t("community.cancelRequest")}
                            </span>
                        ) : (
                            <span onClick={handleJoinCommunity} className="name-likes" style={{ paddingLeft: 0 }}>
                                {isMember ? (
                                    <>
                                        <UserMinus style={{ height: '19px', marginRight: '3px' }}/>{t("community.leave")}
                                    </>
                                ) : (
                                    <>
                                        <UserPlus style={{ height: '19px', marginRight: '3px' }}/>
                                        {community?.is_private ? t("community.requestJoin") : t("community.enter")}
                                    </>
                                )}
                            </span>
                        )}
                    </div>
                </div>

                {/* ── Join requests panel (desktop right sidebar) ── */}
                {community?.is_admin && community?.is_private ? (
                    <div className="card-left" style={{ borderRadius:"50%", marginTop: 12 }}>
                        <h5>{t("community.joinRequests")}</h5>
                        {loadingJoinRequests && <div style={{ textAlign: "center", padding: "10px 0" }}><Spinner /></div>}
                        {!loadingJoinRequests && joinRequests.length === 0 && (
                            <p style={{ fontSize: 13, color: "var(--color-muted)", padding: "8px 0" }}>{t("community.noJoinRequests")}</p>
                        )}
                        {joinRequests.map(r => (
                            <JoinRequestCard key={r.user_id} request={r} onApprove={handleApproveJoin} onReject={handleRejectJoin} />
                        ))}
                    </div>
                ) : null}

                {/* ── Pending posts panel (desktop right sidebar) ── */}
                {community?.is_admin && community?.post_approval ? (
                    <div className="card-left" style={{ borderRadius:"50%", marginTop: 12 }}>
                        <h5>{t("community.pendingPosts")}</h5>
                        {loadingPendingPosts && <div style={{ textAlign: "center", padding: "10px 0" }}><Spinner /></div>}
                        {!loadingPendingPosts && pendingPosts.length === 0 && (
                            <p style={{ fontSize: 13, color: "var(--color-muted)", padding: "8px 0" }}>{t("community.noPendingPosts")}</p>
                        )}
                        {pendingPosts.map(p => (
                            <PendingPostCard key={p.id} post={p} onApprove={handleApprovePost} onReject={handleRejectPost} />
                        ))}
                    </div>
                ): null}
            </RightContent>
            
            <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-4"style={{position: "relative"}}>
                    <NavbarTop />

                    {(!loadingCommunity && community) || loadingCommunity ? (
                        <>
                            <div className="background-group" style={{background: backgroundColor, marginLeft: "0!important", marginRight: "0!important"}}>
                                <div className="row" style={{margin: 0}}>
                                    <div className={`col-2 img-list-chat ${loadingCommunity ? "placeholder placeholder-group" : ""} img-account-search img-capa-group`} style={{backgroundImage: `url('${getImagePathBucketPacoca(community?.img)}')`}}>
                                        <img src={`${getImagePathBucketPacoca(community?.img)}`} alt="Imagem da comunidade" className="img-capa-group" onError={(e) => { e.currentTarget.src = "/img/img-placeholder.jpg"; }}/>
                                        <div id="btn-remove-image" className="btn-remove-file-post">
                                        </div>
                                    </div>
                                    
                                    <div className="col" style={{whiteSpace: "normal"}}>
                                        <h5 style={{whiteSpace: "normal"}} className="name-preview">
                                            {loadingCommunity ? (
                                                <span className="placeholder placeholder-group col-7"></span>
                                            ) : (
                                                <>{community?.name}</>
                                            )}
                                        </h5>
                                        <p className="description-preview" style={{whiteSpace: "normal"}}>
                                            {loadingCommunity ? (
                                                <span className="placeholder placeholder-group col-7"></span>
                                            ) : (
                                                <>{community?.description}</>
                                            )}
                                        </p>

                                        <div className="div-icons-group">
                                            <span onClick={() => { navigate(`/comunidades/membros/${communityId}`) }} className="cursor-pointer">
                                                <Users className="icons-group" data-feather="users"/>
                                                    {community?.total_members && community?.total_members <=0 ? 0 : community?.total_members} 
                                                    {window.innerWidth > 850 ? t("community.members") : null} 
                                                    <ChevronRight color="#fff" size={20} opacity={.6}/>
                                                </span>
                                            <span className="" style={{ cursor: "default" }}>{community?.total_posts && community?.total_posts <=0 ? 0 : community?.total_posts} <MessageSquare className="icons-group" data-feather="message-square"/> <span className="none-cel">Posts</span></span>
                                            {community?.chat_id && isMember && (
                                                <span onClick={() => navigate(`/chat/${community.chat_id}`)} className="cursor-pointer">
                                                    <MessageCircle className="icons-group" size={16}/> 
                                                    {window.innerWidth > 850 ? t("user.chat") : null} 
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* {{-- config do post --}} */}
                                    <div className="col-1 col-conf-post" style={{marginTop: "-0", marginRight: "-10px"}}>
                                        <div className="dropdown">
                                            <button className="none-cel" aria-label="Configuração da Comunidade" style={{border: 0, borderRadius: "5px", background: "transparent"}} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <ChevronDown color="#fff" size={20} opacity={.6}/>
                                            </button>
                                            <button className="none-pc" onClick={() => setOpenSettings(true)} aria-label="Configuração da Comunidade" style={{border: 0, borderRadius: "5px", background: "transparent"}} type="button">
                                                <ChevronDown color="#fff" size={20} style={{ marginTop: 10 }} opacity={.6}/>
                                            </button>

                                            <BottomSheet disableDrag={true} snapPoints={[0, 0.35, 1]} initialSnap={1} setOpen={setOpenSettings} open={openSettings}>
                                                <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                                                    <div className="modal-content modal-content-likes" id="modal-content-likes">
                                                        <div className="modal-header modal-header-comments">
                                                            <div></div>
                                                        </div>
                                                        <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings" style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenSettings(false)}>
                                                             <DropContent handleDelete={handleDelete} isMember={isMember} handleJoinCommunity={handleJoinCommunity} handleCancelJoinRequest={handleCancelJoinRequest} community={community} communityId={communityId} copyLinkCommunity={copyLinkCommunity} onOpenPendingPosts={() => { loadPendingPosts(); setShowPendingPosts(true); setOpenSettings(false); }} onOpenJoinRequests={() => { loadJoinRequests(); setShowJoinRequests(true); setOpenSettings(false); }} pendingCount={pendingPosts.length} joinRequestCount={joinRequests.length}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </BottomSheet>

                                            <ul className="dropdown-menu user-select-none none-cel">
                                                <DropContent handleDelete={handleDelete} isMember={isMember} handleJoinCommunity={handleJoinCommunity} handleCancelJoinRequest={handleCancelJoinRequest} community={community} communityId={communityId} copyLinkCommunity={copyLinkCommunity} onOpenPendingPosts={() => { loadPendingPosts(); setShowPendingPosts(true); }} onOpenJoinRequests={() => { loadJoinRequests(); setShowJoinRequests(true); }} pendingCount={pendingPosts.length} joinRequestCount={joinRequests.length}/>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {isNewUI ? (
                                <button className="button-add-post-feed" {...inputLogin()} style={{ bottom: bottomPadding }}>
                                    <div style={{ marginBottom: -7, marginLeft: 7 }}>
                                        <Icon size={30} style={{ marginRight: 0 }} invertColor={!isDarkMode} name="add">
                                            <Plus opacity={.6} size={23}/>
                                        </Icon>
                                    </div>
                                </button>
                            ): null}

                            {/* ── Tab navigation bar ── */}
                            <div className="community-tabs-bar-wrapper">
                            <div className="community-tabs-bar">
                                <button
                                    className={`community-tab-item${activeTab === "feed" ? " community-tab-active" : ""}`}
                                    onClick={() => setActiveTab("feed")}
                                >
                                    Feed
                                </button>

                                {community?.is_admin && community?.post_approval ? (
                                    <button
                                        className={`community-tab-item${activeTab === "pendingPosts" ? " community-tab-active" : ""}`}
                                        onClick={() => { setActiveTab("pendingPosts"); loadPendingPosts(); }}
                                    >
                                        {t("community.pendingPosts")}
                                        {pendingPosts.length > 0 && (
                                            <span className="community-tab-badge">{pendingPosts.length}</span>
                                        )}
                                    </button>
                                ) : null}

                                {community?.is_admin && community?.is_private ? (
                                    <button
                                        className={`community-tab-item${activeTab === "joinRequests" ? " community-tab-active" : ""}`}
                                        onClick={() => { setActiveTab("joinRequests"); loadJoinRequests(); }}
                                    >
                                        {t("community.joinRequests")}
                                        {joinRequests.length > 0 && (
                                            <span className="community-tab-badge">{joinRequests.length}</span>
                                        )}
                                    </button>
                                ) : null}

                                {window.innerWidth <= 850 && (
                                    <button
                                        className={`community-tab-item${activeTab === "members" ? " community-tab-active" : ""}`}
                                        onClick={() => { setActiveTab("members"); loadMembers(1, true); }}
                                    >
                                        {t("community.members")}
                                    </button>
                                )}

                                <button
                                    className={`community-tab-item${activeTab === "photos" ? " community-tab-active" : ""}`}
                                    onClick={() => { setActiveTab("photos"); if (photoPosts.length === 0) loadMediaPosts("photos", null); }}
                                >
                                    Fotos
                                </button>

                                <button
                                    className={`community-tab-item${activeTab === "videos" ? " community-tab-active" : ""}`}
                                    onClick={() => { setActiveTab("videos"); if (videoPosts.length === 0) loadMediaPosts("videos", null); }}
                                >
                                    Vídeos
                                </button>
                            </div>
                            </div>

                            {/* ── Tab: Feed ── */}
                            {activeTab === "feed" && (
                                <>
                                    {isMember && (!community?.post_approval || community?.is_admin) ? (
                                        <div className="card card-post card-create-post">
                                            <div className="row" style={{ width: "100%", margin: 0, padding: 0, flexWrap: "nowrap" }}>
                                                <div className="col" style={{ paddingRight: 0 }}>
                                                    <input type="file" className="d-none" accept="image/*" title="Inserir imagem" />
                                                    <input {...inputLogin()} type="button" className="form-control text-btn-add-post form-text-comment me-2" name="" value={t("post.textNewPostCommunity")} />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {community?.post_approval && isMember && !community?.is_admin ? (
                                        <div className="card card-post" style={{ padding: "10px 14px", fontSize: 13, color: "var(--color-muted)" }}>
                                            ℹ️ {t("community.pendingInfo")}
                                        </div>
                                    ) : null}

                                    <PostList googleAds onOpenComments={(idPost) => {setShowModalComments(true); setIdPostSelected(idPost)}} onOpenLikes={(idPost) => {setShowModalLikes(true); setIdPostSelected(idPost)}} posts={posts} setPosts={setPosts} />

                                    <div ref={endOfListRef} style={{ height: "20px" }}></div>

                                    {loading && (
                                        <div className="d-flex" style={{ justifyContent: "center", marginTop: "40px" }}>
                                            <LoadingThreeCircle style={{justifyContent: "center"}}/>
                                        </div>
                                    )}

                                    {end && (
                                        <div style={{ textAlign: "center", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                                            <div id="text-carregar" style={{ textAlign: "center", marginTop: "20px" }}>
                                                {t("community.endPosts")}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}

                            {/* ── Tab: Posts pendentes ── */}
                            {activeTab === "pendingPosts" && (
                                <div className="card card-post" style={{ padding: "12px 14px", marginBottom: 10 }}>
                                    <h6 style={{ marginBottom: 10, paddingLeft: 15 }}>{t("community.pendingPosts")}</h6>
                                    {loadingPendingPosts && <div style={{ textAlign: "center", padding: "6px 0" }}><Spinner /></div>}
                                    {!loadingPendingPosts && pendingPosts.length === 0 && (
                                        <p style={{ fontSize: 13, color: "var(--color-muted)" }}>{t("community.noPendingPosts")}</p>
                                    )}
                                    {pendingPosts.map(p => (
                                        <PendingPostCard key={p.id} post={p} onApprove={handleApprovePost} onReject={handleRejectPost} />
                                    ))}
                                </div>
                            )}

                            {/* ── Tab: Solicitações de entrada ── */}
                            {activeTab === "joinRequests" && (
                                <div className="card card-post" style={{ padding: "12px 14px", marginBottom: 10 }}>
                                    <h6 style={{ marginBottom: 10, paddingLeft: 15 }}>{t("community.joinRequests")}</h6>
                                    {loadingJoinRequests && <div style={{ textAlign: "center", padding: "6px 0" }}><Spinner /></div>}
                                    {!loadingJoinRequests && joinRequests.length === 0 && (
                                        <p style={{ fontSize: 13, color: "var(--color-muted)" }}>{t("community.noJoinRequests")}</p>
                                    )}
                                    {joinRequests.map(r => (
                                        <JoinRequestCard key={r.user_id} request={r} onApprove={handleApproveJoin} onReject={handleRejectJoin} />
                                    ))}
                                </div>
                            )}

                            {/* ── Tab: Membros ── */}
                            {activeTab === "members" && (
                                <div className="card card-post" style={{ padding: "12px 14px", marginBottom: 10 }}>
                                    <h6 style={{ marginBottom: 10, paddingLeft: 15 }}>{t("community.members")}</h6>
                                    <MembersContent statusMembers={statusMembers} members={members} termo={termo} handleChange={handleChange} handleKeyDown={handleKeyDown} community={community} setUsers={setMembers} setAdmins={setAdmins} />
                                </div>
                            )}

                            {/* ── Tab: Fotos ── */}
                            {activeTab === "photos" && (
                                <>
                                    {loadingPhotos && photoPosts.length === 0 && (
                                        <div className="d-flex" style={{ justifyContent: "center", marginTop: 40 }}>
                                            <LoadingThreeCircle style={{ justifyContent: "center" }} />
                                        </div>
                                    )}
                                    {!loadingPhotos && photoPosts.length === 0 && endPhotos && (
                                        <div className="card card-post" style={{ padding: "24px 14px", textAlign: "center", color: "var(--color-muted)", fontSize: 14 }}>
                                            Nenhuma foto publicada nesta comunidade ainda.
                                        </div>
                                    )}
                                    {photoPosts.length > 0 && (
                                        <div className="community-media-grid">
                                            {photoPosts.flatMap(post =>
                                                (post.images ?? [])
                                                    .filter((img: any) => img.type === 0)
                                                    .map((img: any, i: number) => (
                                                        <div
                                                            key={`${post.id}-${i}`}
                                                            className="community-media-cell"
                                                            onClick={() => navigate(`/post/${post.id}`)}
                                                        >
                                                            <img
                                                                src={getImagePathBucketPacoca(img.path)}
                                                                alt=""
                                                                loading="lazy"
                                                                onError={e => { (e.currentTarget as HTMLImageElement).src = "/img/img-placeholder.jpg"; }}
                                                            />
                                                        </div>
                                                    ))
                                            )}
                                        </div>
                                    )}
                                    {!endPhotos && photoPosts.length > 0 && (
                                        <div style={{ textAlign: "center", padding: "10px 0" }}>
                                            <button
                                                className="btn btn-sm"
                                                style={{ color: "var(--color-primary, #3b82d4)", background: "none", border: "none", cursor: "pointer" }}
                                                onClick={() => loadMediaPosts("photos")}
                                                disabled={loadingPhotos}
                                            >
                                                {loadingPhotos ? <Spinner /> : "Carregar mais"}
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}

                            {/* ── Tab: Vídeos ── */}
                            {activeTab === "videos" && (
                                <>
                                    {loadingVideos && videoPosts.length === 0 && (
                                        <div className="d-flex" style={{ justifyContent: "center", marginTop: 40 }}>
                                            <LoadingThreeCircle style={{ justifyContent: "center" }} />
                                        </div>
                                    )}
                                    {!loadingVideos && videoPosts.length === 0 && endVideos && (
                                        <div className="card card-post" style={{ padding: "24px 14px", textAlign: "center", color: "var(--color-muted)", fontSize: 14 }}>
                                            Nenhum vídeo publicado nesta comunidade ainda.
                                        </div>
                                    )}
                                    {videoPosts.map(post => {
                                        const videoImg = (post.images ?? []).find((img: any) => img.type === 1);
                                        if (!videoImg) return null;
                                        return (
                                            <div key={post.id} className="card card-post community-video-item">
                                                <video
                                                    src={getImagePathBucketPacoca(videoImg.path)}
                                                    controls
                                                    preload="metadata"
                                                    style={{ width: "100%", borderRadius: 8, maxHeight: 360, background: "#000" }}
                                                />
                                                <div style={{ padding: "6px 8px 2px", fontSize: 13, color: "var(--color-muted)" }}>
                                                    {post.user?.name} · {post.text?.slice(0, 80) ?? ""}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {!endVideos && videoPosts.length > 0 && (
                                        <div style={{ textAlign: "center", padding: "10px 0" }}>
                                            <button
                                                className="btn btn-sm"
                                                style={{ color: "var(--color-primary, #3b82d4)", background: "none", border: "none", cursor: "pointer" }}
                                                onClick={() => loadMediaPosts("videos")}
                                                disabled={loadingVideos}
                                            >
                                                {loadingVideos ? <Spinner /> : "Carregar mais"}
                                            </button>
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <div className="user-select-none row row-empty-comment">
                            <span className="span-empty">
                                <Trash className="icon-empty"  />
                                <h3 className="w-100 text-center">{t("community.deleted")}</h3>
                            </span>
                        </div>
                    )}

                    {/* <AddPost id_community={communityId}/> */}
                    {/* {window.innerWidth <= 850 ? <AddPostBottom id_community={communityId} open={open} setOpen={setOpen}/> : <AddPost id_community={communityId} open={open} setOpen={setOpen}/>} */}
                    <ModalPostLikes idPostSelected={idPostSelected} show={showModalLikes} />
                    {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}
                </div>
            </div>
        </div>
    );
};

function AdminsContent({statusMembers, community, members, termo, handleKeyDown, handleChange, setUsers, setAdmins }: { statusMembers: StatusString, community: Community | null, members: User[] | null, termo: string,handleChange: any, handleKeyDown: any, setUsers?: React.Dispatch<React.SetStateAction<User[] | null>>, setAdmins?: React.Dispatch<React.SetStateAction<User[] | null>> }){
    const { t } = useTranslation();
    return (
        <>
            {statusMembers == StatusString.error ? (
                <IconLateralContent text={t("errors.find.members")}/>
            ): (
                <>
                    {Number(community?.total_members) >11 ? (
                        <div className="d-flex container-search mb-3">
                            <input id="input-search-screen" className="form-control input-search input-search-screen" type="text" name="search" placeholder={t("generics.search")} aria-label="Search" value={termo} onChange={handleChange} onKeyDown={handleKeyDown} required />
                            <button onClick={() => {}} className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button" title="Buscar">
                                <Search color="#d3d3d3" />
                            </button>
                        </div>
                    ) : null}

                    {statusMembers == StatusString.success && !members?.length ? (
                        <IconLateralContent icon={<UserMinus2 size={40}/>} text={t("empty.members")}/>
                    ): null}
                    <UserSearchLoadin loading={statusMembers == StatusString.loading}/>
                    {members?.map((u, index) => (
                        <UserSearch setUsers={setUsers} setAdmins={setAdmins} community={community} hideFollowUser={community?.can_manage_members} isBtnFollowUser={false} key={index} clasNameSearch="name-communities" clasImgAccount="img-user-left" user={u} />
                    ))}
                </>
            )}
        </>
    );
}

function MembersContent({statusMembers, community, members, termo, handleKeyDown, handleChange, setUsers, setAdmins, total, onSeeAll }: { statusMembers: StatusString, community: Community | null, members: User[] | null, termo: string,handleChange: any, handleKeyDown: any, setUsers?: React.Dispatch<React.SetStateAction<User[] | null>>, setAdmins?: React.Dispatch<React.SetStateAction<User[] | null>>, total?: number, onSeeAll?: () => void }){
    const { t } = useTranslation();
    return (
        <>
            {statusMembers == StatusString.error ? (
                <IconLateralContent text={t("errors.find.members")}/>
            ): (
                <>
                    {statusMembers == StatusString.success && !members?.length ? (
                        <IconLateralContent icon={<UserMinus2 size={40}/>} text={t("empty.members")}/>
                    ): null}
                    <UserSearchLoadin loading={statusMembers == StatusString.loading}/>
                    {members?.map((u, index) => (
                        <UserSearch setUsers={setUsers} setAdmins={setAdmins} community={community} hideFollowUser={community?.can_manage_members} isBtnFollowUser={false} key={index} clasNameSearch="name-communities" clasImgAccount="img-user-left" user={u} />
                    ))}
                    {(total ?? 0) > 5 && onSeeAll && (
                        <div style={{ textAlign: "center", paddingTop: 6, paddingBottom: 2 }}>
                            <button
                                onClick={onSeeAll}
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "#7c5022", fontSize: 13, fontWeight: 500 }}
                            >
                                {t("community.seeAllMembers")}
                            </button>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

function PendingPostCard({ post, onApprove, onReject }: { post: any; onApprove: (id: number) => void; onReject: (id: number) => void }) {
    const { t } = useTranslation();
    const [openSettings, setOpenSettings] = useState(false);

    return (
        <div className="card card-post">
            <div className="row row-post" style={{ flexWrap: "nowrap" }}>
                <div className="row row-inside-post">
                    <ImgProfilePost post={post} />
                    <UserName post={post} showContentPost={true}>
                        {post?.text ? (
                            <div className="row row-text-post">
                                <p className="text-post text-post-no-pacocagram post text-expand" style={{ maxHeight: 200, overflow: "hidden" }}>
                                    {post.text}
                                </p>
                            </div>
                        ) : null}
                        {post?.gif_url ? (
                            <div className="row user-select-none row-img-post">
                                <div className="col col-img-post">
                                    <img style={{ marginLeft: 0, width: "100%", height: "100%" }} src={post.gif_url} className="img-post" alt="GIF" />
                                </div>
                            </div>
                        ) : null}
                        {post?.images?.length > 0 ? (
                            <ImgPost images={post.images} post={post} img_account={post?.user?.img_account} />
                        ) : null}
                    </UserName>
                </div>
                <div className="col-1 col-conf-post">
                    <div className="dropdown">
                        <button className="none-cel" aria-label="Opções do post pendente" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <ChevronDown color="var(--color-text-post)" size={20} opacity={.6} />
                        </button>
                        <button className="none-pc" aria-label="Opções do post pendente" style={{ border: 0, borderRadius: "5px", background: "var(--background-post)", padding: 0 }} type="button" onClick={() => setOpenSettings(true)}>
                            <ChevronDown color="var(--color-text-post)" size={20} opacity={.6} />
                        </button>
                        <ul className="dropdown-menu menu-drop none-mobile" style={{ minWidth: "200px" }}>
                            <PendingPostDropItems onApprove={() => onApprove(post.id)} onReject={() => onReject(post.id)} t={t} />
                        </ul>
                    </div>
                    <BottomSheet disableDrag={true} snapPoints={[0, 0.25, 1]} initialSnap={1} setOpen={setOpenSettings} open={openSettings}>
                        <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                            <div className="modal-content modal-content-likes" id="modal-content-likes">
                                <div className="modal-header modal-header-comments">
                                    <div></div>
                                </div>
                                <div className="modal-body modal-body-likes overflow-minus bottom-sheet-profile-settings" style={{ marginTop: 10, marginLeft: 5 }} onClick={() => setOpenSettings(false)}>
                                    <PendingPostDropItems onApprove={() => onApprove(post.id)} onReject={() => onReject(post.id)} t={t} />
                                </div>
                            </div>
                        </div>
                    </BottomSheet>
                </div>
            </div>
        </div>
    );
}

function PendingPostDropItems({ onApprove, onReject, t }: { onApprove: () => void; onReject: () => void; t: any }) {
    return (
        <>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={onApprove}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <Check className="icon-config-post" />
                            {t("community.approvePost")}
                        </div>
                    </div>
                </span>
            </li>
            <li>
                <span className="dropdown-item cursor-pointer user-select-none" onClick={onReject}>
                    <div className="div-icon-fix">
                        <div className="div-icon-block">
                            <X className="icon-config-post" />
                            {t("community.rejectPost")}
                        </div>
                    </div>
                </span>
            </li>
        </>
    );
}

function JoinRequestCard({ request, onApprove, onReject }: { request: any; onApprove: (userId: number) => void; onReject: (userId: number) => void }) {
    const navigate = useNavigate();
    const user = request.user;

    return (
        <div className="row-notification open-notification row-user" style={{ position: "relative" }}>
            <img
                className="col-1 img-user-left user-select-none"
                src={user?.img_account ? getImagePathBucketPacoca(user.img_account) : `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || "U")}`}
                alt=""
                onClick={() => navigate(`/@${user?.user_name}`)}
                onError={(e) => { e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || "U")}`; }}
            />
            <span className="name-likes" style={{ paddingLeft: 0, cursor: "pointer", flex: 1 }} onClick={() => navigate(`/@${user?.user_name}`)}>
                {user?.name}
            </span>
            <div style={{ display: "flex", gap: 4, flexShrink: 0, alignItems: "center" }}>
                <button
                    onClick={() => onApprove(request.user_id)}
                    title="Aprovar"
                    style={{ border: 0, background: "transparent", padding: "4px", cursor: "pointer", display: "flex", alignItems: "center" }}
                >
                    <Check size={18} color="var(--color-success, #198754)" />
                </button>
                <button
                    onClick={() => onReject(request.user_id)}
                    title="Recusar"
                    style={{ border: 0, background: "transparent", padding: "4px", cursor: "pointer", display: "flex", alignItems: "center" }}
                >
                    <X size={18} color="var(--color-danger, #dc3545)" />
                </button>
            </div>
        </div>
    );
}

function DropContent({
  copyLinkCommunity,
  community,
  handleDelete,
  communityId,
  isMember,
  handleJoinCommunity,
  handleCancelJoinRequest,
  onOpenPendingPosts,
  onOpenJoinRequests,
  pendingCount,
  joinRequestCount,
}: {
  copyLinkCommunity: any,
  community: Community | null,
  communityId?: string,
  handleDelete?: any,
  handleJoinCommunity?: any,
  handleCancelJoinRequest?: any,
  isMember?: any,
  onOpenPendingPosts?: () => void,
  onOpenJoinRequests?: () => void,
  pendingCount?: number,
  joinRequestCount?: number,
}){
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (

        <>
            {community?.can_edit ? (
                <>
                    <li>
                        <span className="dropdown-item cursor-pointer user-select-none">
                            <div className="div-icon-fix">
                                <Link style={{ padding: 0 }}  type="button" className="dropdown-item" to={`/comunidades/editar/${communityId}`}>
                                    <Edit data-feather="edit" className="icon-config-post"/>{t("community.edit")}
                                </Link>
                            </div>
                        </span>
                    </li>
                </>
            ) : null }

            {community?.is_admin && community?.post_approval ? (
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={onOpenPendingPosts}>
                        <div className="div-icon-fix">
                            <ClipboardList className="icon-config-post" /> {t("community.pendingPosts")}
                            {pendingCount != null && pendingCount > 0 && (
                                <span style={{ background: "#e74c3c", color: "#fff", borderRadius: "10px", padding: "1px 7px", marginLeft: "6px", fontSize: "11px" }}>{pendingCount}</span>
                            )}
                        </div>
                    </span>
                </li>
            ) : null}

            {community?.is_admin && community?.is_private ? (
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={onOpenJoinRequests}>
                        <div className="div-icon-fix">
                            <UserPlus className="icon-config-post" /> {t("community.joinRequests")}
                            {joinRequestCount != null && joinRequestCount > 0 && (
                                <span style={{ background: "#e74c3c", color: "#fff", borderRadius: "10px", padding: "1px 7px", marginLeft: "6px", fontSize: "11px" }}>{joinRequestCount}</span>
                            )}
                        </div>
                    </span>
                </li>
            ) : null}
            
            {community?.can_delete ? (
                <>
                    <li>
                        <span className="dropdown-item cursor-pointer user-select-none" onClick={handleDelete}>
                            <div className="div-icon-fix">
                                <Trash2 data-feather="trash" className="icon-config-post"/>{t("community.delete")}
                            </div>
                        </span>
                    </li>
                </>
            ) : null }

            {community?.chat_id && isMember && (
                <li onClick={() => navigate(`/chat/${community.chat_id}`)}>
                    <span className="dropdown-item cursor-pointer user-select-none">
                        <div className="div-icon-fix">
                            <MessageCircle className="icon-config-post"/> {t("community.chat")}
                        </div>
                    </span>
                </li>
            )}

            <li onClick={() => copyLinkCommunity(communityId)}>
                <span className="dropdown-item cursor-pointer user-select-none">
                    <div className="div-icon-fix">
                        <Copy data-feather="copy" className="icon-config-post"/>{t("community.copyLink")}
                    </div>
                </span>
            </li>
            {community?.pending_join ? (
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={handleCancelJoinRequest}>
                        <div className="div-icon-fix">
                            <Clock className="icon-config-post"/>{t("community.cancelRequest")}
                        </div>
                    </span>
                </li>
            ) : (
                <li>
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={handleJoinCommunity}>
                        <div className="div-icon-fix">
                            {isMember ? (
                                <>
                                    <UserMinus data-feather="copy" className="icon-config-post"/>{t("community.leave")}
                                </>
                            ) : (
                                <>
                                    <UserPlus data-feather="copy" className="icon-config-post"/>
                                    {community?.is_private ? t("community.requestJoin") : t("community.enter")}
                                </>
                            )}
                        </div>
                    </span>
                </li>
            )}
        </>
    );
}

function AllMembersModal({
    communityId,
    token,
    community,
    setUsers,
    setAdmins,
    onClose,
}: {
    communityId: string;
    token: string | null;
    community: Community | null;
    setUsers?: React.Dispatch<React.SetStateAction<User[] | null>>;
    setAdmins?: React.Dispatch<React.SetStateAction<User[] | null>>;
    onClose: () => void;
}) {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [allMembers, setAllMembers] = useState<User[]>([]);
    const [status, setStatus] = useState<StatusString>(StatusString.loading);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const LIMIT = 20;
    const isMobile = window.innerWidth <= 850;

    const debouncedSetSearch = useCallback(debounce((v: string) => setDebouncedSearch(v), 400), []);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
        debouncedSetSearch(e.target.value);
    };

    const loadPage = useCallback(async (pg: number, q: string, append: boolean) => {
        if (!append) setStatus(StatusString.loading);
        else setLoadingMore(true);
        try {
            const response = await axios.get(
                `${PACOCA_API_URL}/communities/members/${communityId}?search=${encodeURIComponent(q)}&just_admin=0&limit=${LIMIT}&page=${pg}`,
                { headers: { "Accept": "application/json", "Authorization": `Bearer ${token}` } }
            );
            const data: User[] = response.data.users ?? [];
            if (append) {
                setAllMembers(prev => {
                    const ids = new Set(prev.map(u => u.id));
                    return [...prev, ...data.filter(u => !ids.has(u.id))];
                });
            } else {
                setAllMembers(data);
            }
            setHasMore(data.length === LIMIT);
            setStatus(StatusString.success);
        } catch {
            setStatus(StatusString.error);
        } finally {
            setLoadingMore(false);
        }
    }, [communityId, token]);

    // Initial load + reload on search change
    useEffect(() => {
        setPage(1);
        setHasMore(true);
        loadPage(1, debouncedSearch, false);
    }, [debouncedSearch, loadPage]);

    const loadMore = () => {
        const next = page + 1;
        setPage(next);
        loadPage(next, debouncedSearch, true);
    };

    const inner = (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px 8px" }}>
                <strong style={{ fontSize: 15 }}>{t("community.members")} {community?.total_members ? `(${community.total_members})` : ""}</strong>
                <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center" }}>
                    <X size={20} color="var(--color-text-post)" />
                </button>
            </div>

            {/* Search */}
            <div className="d-flex container-search" style={{ padding: "0 14px 10px" }}>
                <input
                    className="form-control input-search input-search-screen"
                    type="text"
                    placeholder={t("generics.search")}
                    value={search}
                    onChange={handleSearchChange}
                    autoFocus
                />
                <button className="btn-search btn-search-screen input-search-screen-icon-menu-dark btn" type="button">
                    <Search color="#d3d3d3" />
                </button>
            </div>

            {/* List */}
            <div style={{ flex: 1, overflowY: "auto", padding: "0 8px" }}>
                <UserSearchLoadin loading={status === StatusString.loading} />
                {status === StatusString.error && <IconLateralContent text={t("errors.find.members")} />}
                {status === StatusString.success && allMembers.length === 0 && (
                    <IconLateralContent icon={<UserMinus2 size={40} />} text={t("empty.members")} />
                )}
                {allMembers.map((u, i) => (
                    <UserSearch
                        key={i}
                        setUsers={setUsers}
                        setAdmins={setAdmins}
                        community={community}
                        hideFollowUser={community?.can_manage_members}
                        isBtnFollowUser={false}
                        clasNameSearch="name-communities"
                        clasImgAccount="img-user-left"
                        user={u}
                    />
                ))}
                {hasMore && status === StatusString.success && allMembers.length > 0 && (
                    <div style={{ textAlign: "center", padding: "10px 0" }}>
                        <button
                            onClick={loadMore}
                            disabled={loadingMore}
                            style={{ background: "none", border: "none", cursor: "pointer", color: "#7c5022", fontSize: 13 }}
                        >
                            {loadingMore ? <Spinner /> : t("generics.loadMore")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );

    if (isMobile) {
        return (
            <BottomSheet disableDrag={false} snapPoints={[0, 0.6, 1]} initialSnap={1} setOpen={(v) => { if (!v) onClose(); }} open={true}>
                <div className="modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" role="document">
                    <div className="modal-content modal-content-likes" id="modal-content-all-members" style={{ minHeight: "50vh" }}>
                        {inner}
                    </div>
                </div>
            </BottomSheet>
        );
    }

    // Desktop: inline overlay inside the card-left
    return (
        <div
            style={{
                position: "fixed",
                top: 0, left: 0, right: 0, bottom: 0,
                zIndex: 1050,
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div
                style={{
                    background: "var(--background-post)",
                    borderRadius: 10,
                    width: 340,
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "calc(50% - 680px)",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
                    overflow: "hidden",
                }}
            >
                {inner}
            </div>
        </div>
    );
}

export default ViewCommunity;
